// extracted by mini-css-extract-plugin
export default {"counterUp":"CountUpAnimation_counterUp__dBaT3","countItem":"CountUpAnimation_countItem__0zxYm"};